/* global axios */
import ApiClient from './ApiClient';

class AtecPaymentMethodsAPI extends ApiClient {
  constructor() {
    super('atec_payment_methods', { accountScoped: true });
  }

  fetch() {
    if (typeof window !== 'undefined' && window.axios)
      return window.axios.get(this.url);
    return axios.get(this.url);
  }
}

export default new AtecPaymentMethodsAPI();
